import React, { useState, useEffect, useMemo } from 'react';
import { LOADING_STAGES } from '../constants/models';

const TIPS = [
  'Try adding style keywords like "cinematic", "dramatic lighting", or "volumetric fog"',
  'Be specific with camera angles: "low angle shot", "bird\'s eye view"',
  'Mention art styles: "oil painting", "watercolor", "digital art"',
  'Include atmosphere details: "golden hour", "misty morning", "neon lit"',
  'Add composition hints: "rule of thirds", "symmetrical", "close-up"',
];

export default function LoadingOverlay({ type = 'image' }) {
  const [activeStage, setActiveStage] = useState(0);
  const [tipIdx, setTipIdx] = useState(0);

  const tip = useMemo(() => TIPS[tipIdx], [tipIdx]);

  useEffect(() => {
    setTipIdx(Math.floor(Math.random() * TIPS.length));
  }, []);

  useEffect(() => {
    const intervals = type === 'video' ? [2000, 6000, 10000] : [1500, 4000, 7000];
    const timers = intervals.map((delay, idx) =>
      setTimeout(() => setActiveStage(idx + 1), delay)
    );
    return () => timers.forEach(clearTimeout);
  }, [type]);

  const progress = ((activeStage + 1) / LOADING_STAGES.length) * 100;

  return (
    <div className="load-overlay">
      <div className="load-orb" />

      <div className="load-logo">aiField</div>

      <div style={{ fontSize: 14, color: 'var(--t2)', marginBottom: 4 }}>
        Generating your {type === 'video' ? 'video' : 'image'}…
      </div>

      <div className="load-stages">
        {LOADING_STAGES.map((stage, i) => (
          <div key={stage.key} className={`load-stage ${i === activeStage ? 'active' : ''} ${i < activeStage ? 'done' : ''}`}>
            <span className="stage-dot" />
            <span className="stage-icon">{stage.icon}</span>
            <span>{stage.label}</span>
            {i < activeStage && <span style={{ marginLeft: 'auto', fontSize: 10, color: 'var(--gr)' }}>✓</span>}
          </div>
        ))}
      </div>

      <div className="load-progress">
        <div className="load-progress-bar" style={{ width: `${progress}%` }} />
      </div>

      <div className="load-tip">
        <span style={{ color: 'var(--ac3)', fontWeight: 700 }}>💡 Tip: </span>
        {tip}
      </div>
    </div>
  );
}
